import App from "./js/App";

function main() {
  const app = new App();
}
main();
